export default __webpack_public_path__ + "static/media/049-bomb.ebaa2ac7.png";